import { Spin } from 'antd';
import { cloneDeep } from 'es-toolkit';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CLAIMS_TOTAL_COUNTS_TYPES,
  LOSS_AND_DAMAGE_CLAIMS_FILTERS_INITIAL_DATA,
} from '../../../../../contants/ClaimsEnums';
import { SEARCH_VIEW_TYPES } from '../../../../../contants/common';
import {
  getLossAndDamageClaimDetailsInProgress,
  getLossAndDamageListInProgress,
  setLADClaimEditDrawer,
  setLossAndDamageClaimsList,
  setLossAndDamageFilters,
  setSelectedLADClaims,
} from '../../../../../redux/Claims/LossAndDamage/LossAndDamageClaimsActions';
import { setPageBlocker } from '../../../../../redux/common/CommonActions';
import EmptyRecords from '../../../../components/Common/EmptyRecords';
import Drawer from '../../../../components/Modals/Drawer';
import ScrollPagination from '../../../../components/Paginations/ScrollPagination';
import Paper from '../../../../components/Paper/Paper';
import LADDrawerHeader from '../Edit/LADDrawerHeader';
import LADEditTabs from '../Edit/LADEditTabs';
import LDTableView from './LDTableView';
import LossAndDamageListCard from './LossAndDamageListCard';

const LossAndDamageList = () => {
  const dispatch = useDispatch();
  const selectedCompany = useSelector((state) => state.auth.selectedCompany);

  const { claimsList, filters, selectedClaims, editDrawer, claimDetails, claimViewMode } = useSelector(
    (state) => state.lossAndDamage,
  );

  const totalPageCount = useMemo(
    () =>
      Math.floor(
        (claimsList?.footerData?.[CLAIMS_TOTAL_COUNTS_TYPES[filters.FooterStatus]] + (filters.pageSize - 1)) /
          filters.pageSize,
      ),
    [claimsList, filters],
  );

  const handleLoadMore = () => {
    dispatch(setLossAndDamageFilters({ pageNo: filters.pageNo + 1 }));
    dispatch(getLossAndDamageListInProgress());
  };

  useEffect(() => {
    if (selectedCompany?.companyId) {
      dispatch(
        setLossAndDamageFilters({
          ...LOSS_AND_DAMAGE_CLAIMS_FILTERS_INITIAL_DATA,
          pageNo: 1,
        }),
      );
      dispatch(setLossAndDamageClaimsList({ data: [], isFirstTime: true }));
    }
  }, [selectedCompany?.companyId]);

  const onSelect = (id, remove) => {
    const selectedClaimLocal = cloneDeep(selectedClaims);
    if (!remove) {
      selectedClaimLocal.push(id);
    } else {
      const index = selectedClaimLocal.indexOf(id);
      selectedClaimLocal.splice(index, 1);
    }
    dispatch(setSelectedLADClaims(selectedClaimLocal));
  };

  const handlePageBlockerAfterClosingEditDrawer = () => {
    dispatch(setLADClaimEditDrawer(false));
    dispatch(setPageBlocker(false));
  };

  const handleClaimClick = (claimKey) => {
    dispatch(getLossAndDamageClaimDetailsInProgress(claimKey));
    dispatch(setLADClaimEditDrawer(true));
  };

  const handleAfterEditDrawerClosed = (val) => {
    if (!val) {
      dispatch(setPageBlocker(false));
    }
  };

  const isCardView = useMemo(() => claimViewMode === SEARCH_VIEW_TYPES.CARD, [claimViewMode]);

  return (
    <>
      <div className="h-100 pt-15 d-flex flex-direction-column">
        <>
          {isCardView ? (
            <>
              {claimsList.isFirstTime ? (
                <Paper className="h-100 w-100 mb-15" />
              ) : (
                <ScrollPagination
                  className={`${claimsList?.data?.length > 0 ? 'mb-15' : 'pb-15'} h-100`}
                  loadMore={handleLoadMore}
                  hasMore={claimsList.progressing ? false : filters?.pageNo < totalPageCount}
                  isLoading={claimsList.progressing}
                  scrollOffset={50}
                >
                  {claimsList?.data && claimsList?.data.length > 0 ? (
                    claimsList?.data.map((row) => (
                      <div className="mb-15" key={row.claimKey}>
                        <LossAndDamageListCard
                          data={row}
                          handleClaimClick={handleClaimClick}
                          onSelect={onSelect}
                          isSelected={selectedClaims.includes(row.claimKey)}
                        />
                      </div>
                    ))
                  ) : (
                    <>{!claimsList.progressing && <EmptyRecords />}</>
                  )}
                </ScrollPagination>
              )}
            </>
          ) : (
            <LDTableView
              handleLoadMore={handleLoadMore}
              isLoading={claimsList.progressing}
              hasMore={claimsList.progressing ? false : filters?.pageNo < totalPageCount}
              claimsList={claimsList?.data ? claimsList.data : []}
              handleShipmentClick={handleClaimClick}
              onSelect={onSelect}
              selectedClaims={selectedClaims}
              isFirstTime={claimsList.isFirstTime}
            />
          )}
        </>
      </div>
      <Drawer
        visible={editDrawer}
        onClose={handlePageBlockerAfterClosingEditDrawer}
        headerContents={<LADDrawerHeader claimData={claimDetails?.data} />}
        width="90%"
        afterOpenChange={handleAfterEditDrawerClosed}
        destroyOnClose
      >
        <Spin
          size="large"
          spinning={claimDetails?.progressing}
          wrapperClassName="h-100 overflow-hidden shipment-drawer-root-spinner"
        >
          <LADEditTabs />
        </Spin>
      </Drawer>
    </>
  );
};

export default LossAndDamageList;
